// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1nrwd","location":"Header_location__2BfKk"};